import { useEffect } from "react";

// Ctrl+S is claimed by the browser, Ctrl+Enter is free both in Teams and in the browser
function isSaveShortcut(e: KeyboardEvent) {
    if (!e.ctrlKey && !e.metaKey) { return false; }

    return e.key?.toLowerCase() === "s" || e.key === "Enter";
}

export default function useSaveShortcut(save: () => void, enabled: boolean) {
    useEffect(() => {
        function handleKeyDown(e: KeyboardEvent) {
            if (e.repeat || !isSaveShortcut(e)) { return; }

            // The default is suppressed even when the form cannot be saved,
            // otherwise the browser would offer to save the page itself
            e.preventDefault();
            if (enabled) { save(); }
        }

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [save, enabled]);
}
